import {createSlice} from "@reduxjs/toolkit";

const initialState={
  curPage:"default",
  prePage:"default",
  loading:false,
  brands:[],
  variants:[],
  skus:[],
  flavours:[],
  weights:[],
  packshots:[],
  selectedBrand:null,
  selectedVariant:null,
  selectedWeight:null,
  selectedFlavour:null,
  selectedProject:null,
  selectedSku:null,
  open:false,
  clickedThumbnail:null,
  anchor:null,
  toggle:false
  }

const pageSlice = createSlice({
    name: "conflictsPage",
    initialState,
    reducers: {
     setLoading:(state,action)=>{
        state.loading=action.payload
     },
     setCurPage:(state,action)=>{
      state.curPage=action.payload
     },
     setPrevPage:(state,action)=>{
        state.prePage=action.payload
     },
     setSelectedProject:(state,action)=>{
       state.selectedProject=action.payload
     },
     setBrands:(state,action)=>{
       state.brands=action.payload;
     },
     setVariants:(state,action)=>{
      state.variants=action.payload
     },
     setWeights:(state,action)=>{
      state.weights=action.payload
     },
     setFlavours:(state,action)=>{
      state.flavours=action.payload
     },
     setSkus:(state,action)=>{
      state.skus=action.payload
     },
     setPackshots:(state,action)=>{
       state.packshots=action.payload
     },
     setSelectedBrand:(state,action)=>{
      state.selectedBrand=action.payload
     },
     setSelectedVariant:(state,action)=>{
      state.selectedVariant=action.payload
     },
     setSelectedFlavour:(state,action)=>{
      state.selectedFlavour=action.payload
     },
     setSelectedWeight:(state,action)=>{
      state.selectedWeight=action.payload
     },
     setSelectedSku:(state,action)=>{
      state.selectedSku=action.payload
     },
     setOpenClicked:(state,action)=>{
      state.open=action.payload
     },
     setClickedThumbnail:(state,action)=>{
      state.clickedThumbnail=action.payload
     },
     setAnchor:(state,action)=>{
      state.anchor=action.payload
     },
     setToggle:(state,action)=>{
      state.toggle=action.payload
     },
     resetState:(state,action)=>{
      state.clickedThumbnail=null;
      state.flavours=[];
      state.packshots=[];
      state.variants=[];
      state.skus=[];
      state.weights=[];
      state.selectedBrand=null;
      state.selectedFlavour=null;
      state.selectedSku=null;
      state.selectedVariant=null;
      state.selectedWeight=null
     },
     resetAllDataOfPopUp:(state,action)=>{
      state.clickedThumbnail=null;
      state.brands=[];
      state.flavours=[];
      state.packshots=[];
      state.variants=[];
      state.skus=[];
      state.weights=[];
      state.selectedBrand=null;
      state.selectedFlavour=null;
      state.selectedSku=null;
      state.selectedVariant=null;
      state.selectedWeight=null;
      state.open=false;
      state.anchor=null
     },
     resetAllDataOfPopUpOnTabChange:(state,action)=>{
      state.brands=[];
      state.flavours=[];
      state.packshots=[];
      state.variants=[];
      state.skus=[];
      state.weights=[];
      state.selectedBrand=null;
      state.selectedFlavour=null;
      state.selectedSku=null;
      state.selectedVariant=null;
      state.selectedWeight=null;
     }
      
    }
  });

export const {resetAllDataOfPopUpOnTabChange,setSelectedProject,resetAllDataOfPopUp,resetState,setLoading,setPrevPage,setCurPage,setBrands,setVariants,setSkus,setFlavours,setWeights,setPackshots,setSelectedBrand,setSelectedFlavour,setSelectedSku,setSelectedVariant,setSelectedWeight,setOpenClicked,setClickedThumbnail,setAnchor,setToggle}= pageSlice.actions;

export default pageSlice.reducer;